export default function (state = {
    admin: { search_string: '', list:{}, details:{}, validation:{}, options:{}}
    }, action) {
    switch(action.type) {
        case 'ADMIN_UPDATE_SEARCH_STRING':
            state.admin.search_string = action.value;
        return { ...state };
        case 'ADMIN_SEARCH':
            state.admin.list = action.data.list;
            return { ...state };
        case 'ADMIN_OPTIONS':
            state.admin.options = action.data.options;
            return { ...state };
        case 'ADMIN_DETAILS':
            state.admin.details = action.data.record;
            return { ...state };
        case 'ADMIN_UPDATE_FORM':
            state.admin.details[action.field] = action.value;
            if (state.admin.validation[action.field]) {
                state.admin.validation[action.field] = {};
            }
            return { ...state };
        case 'ADMIN_VALIDATION_ERROR':
            state.admin.validation = action.data;
            return { ...state };
        case 'ADMIN_SELECTED':
            state.admin.selected = action.value;
            state.admin.details = {};
            state.admin.validation = {};
            return { ...state };
        case 'ADMIN_DESELECTED':
        case 'ADMIN_UPDATED':
        case 'ADMIN_INSERTED':
        case 'ADMIN_DELETED':
            state.admin.selected = null;
            state.admin.details = {};
            state.admin.validation = {};
            return { ...state };
        case 'ADMIN_CANCEL_SELECT':
            state.admin.selected = null;
            return { ...state };
        case 'ADMIN_INSERT_ERROR':
        case 'ADMIN_UPDATE_ERROR':
            state.admin = {};
            return { ...state };
        default:
            break;
    }
    return state;
}

